import React from "react";
import { NavLink } from "react-router-dom";
import Signup from "../components/Signup";
import { ROUTES } from "../routes/routes";
import "./css/SignupPage.css";

function SignupPage() {
  return (
    <div className="signup-container">
      <div className="signup-left-column">
        <div className="brand-container">
          <NavLink to={ROUTES.Home()} className="brand-title">
            <img src="/white_logo.png" alt="Render FM Logo" className="brand-logo" />
            <h1>Render FM</h1>
          </NavLink>
          <p className="brand-tagline">
            Taking Audio Visualisations up a notch
          </p>
        </div>
      </div>
      <div className="signup-right-column">
        <div className="signup-brand-header">
          <NavLink to={ROUTES.Home()} className="signup-brand-title">
            <img src="/black_logo.png" alt="Render FM Logo" className="signup-brand-logo" />
            Render FM
          </NavLink>
        </div>
        <div className="signup-top-menu-mobile">
          <div className="signup-top-menu-container">
            <NavLink to={ROUTES.Home()} className="signup-top-menu-brand">
              <img src="/pink_logo.png" alt="Render FM Logo" className="signup-mobile-logo" />
              Render FM
            </NavLink>
          </div>
        </div>
        <Signup />
      </div>
    </div>
  );
}

export default SignupPage;